import moment from 'moment';
import get from 'lodash/get';

import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import config from '../../config/config';

const Review = props => {
  const { review, color } = props;
  const r = review;
  console.log('R', review);
  return (
    <Box className='ReviewComponent'>
      <Stack spacing={1} style={{ marginBottom: '1em' }}>
        <Rating
          defaultValue={get(r, 'rating')}
          readOnly
          style={{
            fontSize: '1rem',
            color: color || config().colors.primary,
            paddingTop: "5px",
            paddingBottom: "10px",
          }}
        />
        <Box>
          <Typography variant='paragraphSmallInter' color='text.primary'>
            {get(r, 'feedback', '')}
          </Typography>
        </Box>
        <Stack direction='row' justifyContent='space-between'>
          <Typography variant='paragraphSmallInter' color='text.muted'>
            {get(r, 'author_first_name', '')}
          </Typography>
          <Typography variant='paragraphSmallInter' color='text.muted'>
            {moment(get(r, 'created_date')).format('MMM yy')}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Review;
